import { Platform } from 'react-native';

/** IANA zone of this device, or null when it cannot be read (the server then falls back to the profile zone or UTC). */
export const getDeviceTimeZone = (): string | null => {
  try {
    if (Platform.OS !== 'web') {
      // Lazy: the native module is not available in every test/web environment.
      const RNLocalize = require('react-native-localize');
      const zone = RNLocalize.getTimeZone?.();
      if (typeof zone === 'string' && zone.length > 0) return zone;
    }
    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return typeof zone === 'string' && zone.length > 0 ? zone : null;
  } catch {
    return null;
  }
};
